var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.router.includes(_vm.$route.path))?_c('Top',{on:{"child":_vm.handlechild}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }